import React from "react";

export const Loading = ({show}) => {
    return (
        <div className={`loading ${show ? 'show' : 'hide'}`}>
            <img src={ require(`../../assets/images/svgs/loading.svg`).default} />
        </div>
    );
}